// Client-side counterpart to backend/src/utils/messageTemplate.js's fillPlaceholders —
// used only by send sites that build a wa.me deep link straight in the browser (no
// server round-trip), currently the Payment Link / Advance Link buttons on the admin
// Customer Detail page and the agent app.
export function pickTemplate(templates, category) {
  return (templates || []).find(t => t.category === category && t.isActive !== false) || null;
}

export function fillTemplate(body, vars) {
  return String(body || '').replace(/\{\{(\w+)\}\}/g, (_, key) => (vars[key] ?? ''));
}
